export default __webpack_public_path__ + "static/media/i223jp.ee8944ff.webp";